import featurWalkthrough from '~/assets/images/header/Checkmark.svg';
import videoWalkthrough from '~/assets/images/header/PlayButton.svg';
import salesTipbulb from '~/assets/images/header/Idea.svg';

export const selectHeaderItem = [
    { value: 2, item: "Introduction Video", icon: videoWalkthrough },
    { value: 1, item: "Dashboard Walkthrough", icon: featurWalkthrough },
    { value: 0, item: "Sales Tip", icon: salesTipbulb },
    { value: 3, item: "Help Center", icon: salesTipbulb }];
